<template>
  <div style="position: absolute; left: 0; top: 0; width: 100%">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#000"
      text-color="#fff"
      active-text-color="#fff"
    >
      <el-menu-item index="2"
        ><img src="../assets/newImg/pf.png" class="icon1" />{{
          $t("info.lang.function2")
        }}</el-menu-item
      >

      <el-submenu index="3">
        <template slot="title"
          ><img src="../assets/newImg/dz.png" class="icon1" />{{
            $t("info.lang.function3")
          }}</template
        >
        <el-menu-item index="3-1">{{ $t("info.lang.action1") }}</el-menu-item>
        <el-menu-item index="3-2">{{ $t("info.lang.action2") }}</el-menu-item>
      </el-submenu>

      <el-submenu index="1">
        <template slot="title"
          ><img src="../assets/newImg/wz.png" class="icon1" />{{
            $t("info.lang.function1")
          }}</template
        >
        <el-menu-item index="1-1">1.{{ $t("info.lang.roam1") }}</el-menu-item>
        <el-menu-item index="1-2">2.{{ $t("info.lang.roam2") }}</el-menu-item>
        <el-menu-item index="1-4">3.{{ $t("info.lang.roam4") }}</el-menu-item>
        <el-menu-item index="1-5">4.{{ $t("info.lang.roam5") }}</el-menu-item>
        <el-menu-item index="1-3">5.{{ $t("info.lang.roam3") }}</el-menu-item>
      </el-submenu>

      <transition
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft"
      >
        <chose-role v-if="changeFlag" @close="closeFlag" />
      </transition>
      <p class="loginOut" @click="loginOut">
        <img src="../assets/newImg/tc.png" class="icon1" />{{ $t("info.lang.logOut") }}
      </p>
      <div class="right1" v-if="auth > 2">
        <el-submenu index="5">
          <template slot="title"
            ><img src="../assets/newImg/new.png" class="icon1" />{{
              $t("info.lang.function6")
            }}</template
          >
          <el-menu-item
            :index="'5-' + index"
            v-for="(item, index) in blist[0]"
            :key="index"
            >{{ item }}</el-menu-item
          >
        </el-submenu>
      </div>
      <div class="right1" v-if="auth > 2">
        <el-submenu index="4">
          <template slot="title"
            ><img src="../assets/newImg/new.png" class="icon1" />{{
              $t("info.lang.function5")
            }}</template
          >
          <el-menu-item
            :index="'4-' + index"
            v-for="(item, index) in alist[0]"
            :key="index"
            >{{ item }}</el-menu-item
          >
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>
<script>
import choseRole from "./choseRole.vue";
import choseMsg from "./choseMsg.vue";
import UserList from "./userList.vue";
import { save, check_code } from "../assets/api/index";
export default {
  components: { choseRole, choseMsg, UserList },
  data() {
    return {
      activeIndex: "99",
      changeFlag: false,
      msgFlag: false,
      roleList: [
        require("../assets/img/role1.jpg"),
        require("../assets/img/role2.jpg"),
        require("../assets/img/role3.png"),
        require("../assets/img/role4.png"),
        require("../assets/img/role5.jpg"),
        require("../assets/img/role6.jpg"),
      ],

      role: "",
      auth: 0,
      userFlag: false,
      auth: "",
      alist: [
        [
          "木槿 (6/23 11h30- 16h30)",
          "蚁触科技 (6/23 11h- 16h)",
          "尼欧数字 (6/24 10h- 16h)",
          "Matterverse (6/23 12h30- 17h30)",
          "零一裂变 (6/22 10h- 15h)",
          "小蚁 (6/22 11h- 16h)",
          "B+油罐 (6/23 10h- 15h)",
          "糖豆 (6/24 10h- 16h)",
          "声网 (6/23 12h30- 17h)",
          "Output (6/22 11h- 16h)",
          "述信 (6/22 10h30- 15h30)",
          "深度赋智 (6/23 12h30- 17h30)",
          "唯链 (6/22 11h- 16h)",
          "灵售物联 (6/23 10h- 15h)",
          "维妥科技 (6/23 10h30- 15h30)",
          "有米云 (6/23 10h30- 15h30)",
          "影眸科技 (6/22 11h30- 16h30)",
          "美图宜肤 (6/23 11h- 16h)",
          "昆氏生物 (6/22 10h30- 15h30)",
          "睿效科技 (6/22 11h30- 16h30)",
          "Mogic AI (6/23 12h- 17h)",
          "Versa (6/23 12h- 17h)",
          "右侧智能 (6/22 11h30- 16h30)",
        ],
        [
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_YmFlN2Q0ZjEtZTBhZi00MDQ3LTg3N2MtYWRkY2ZiMzA2M2Fj%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=99372ef5-b168-4e46-aea5-b3dc50f1ea19&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_NzhlNGI0NjUtOWRjYS00OGExLTliNjMtZjM0ZTMwYWVkYzA3%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=2bede04f-2f58-4b85-99f8-ad574847ba66&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_Yjc0YmJkNmYtN2M4Zi00MDliLTliYzYtOTI4ODFjMWU4ZTBi%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=be49e537-e015-4078-936c-4e9da15ebade&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_MWMwNWQ1MGQtZWZkOC00NDE0LThkM2YtZTI0OTk0MzFhMmNm%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=562e4900-7153-40f7-8528-a06008a3dbce&directDl=true&msLaunch=true&enableMobilePage=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_YmRkNWYwZjEtMzUwNS00Yzc3LTliMjAtYThhNGRmNjcxOTIy%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=58b8c2a2-8a8a-4257-bd1e-65a1266d367b&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_N2ZhNmQxYTktOGU3Yi00NGIxLThmYTEtZjk4Y2FhMWFiMzQ3%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=fbc31acd-467f-4780-8dee-fa2db9d37b1b&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_NGUwMWYyNWItNDdlMC00OTcwLWI1NGYtNzFiYWQ0NTU1YmZk%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=004c9bd7-b644-454b-83c5-caabfab5d5cb&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_MjQ4YzAwZTEtNTM2ZC00YzYyLWI5ZjQtZjdmMDFhMWExZDk1%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=f5f097dc-754c-4141-b337-1623c5fc2840&directDl=true&msLaunch=true&enableMobilePage=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_N2JmMjFhYTctOThmNy00ZDdkLWEzNzMtODRmNzE4ZjIwZjlk%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=a3c6e2c2-246c-404f-8e05-c973287b15f4&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_MzBhMzEwNWItZDU3Zi00NTRlLTgyOGMtMmRlZTZlNmNiYWJj%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=97edf5dc-c74e-48f0-8dac-0fe3c07ca725&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_OWM4NGUxYmItMDllOC00ZTJjLTgwNDgtNmI1OGMzOTFmYzM1%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=077808fc-86a5-4a34-bbfb-5114165ec252&directDl=true&msLaunch=true&enableMobilePage=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_ZjU5ZmM2MzEtNWJiZi00M2I0LTkwYjgtZGEzODU2Mzc4Yjgy%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=c044d6fc-0b09-4133-8d05-c08e89a84231&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_MDRhNWI5ODQtZWIzZC00MmY5LWJmZDQtNjg5OWJmMGI3NDk1%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=270c3440-c90c-4f34-892c-19991a43949b&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_NDBiZDA3OGUtZDM3Zi00MDFiLTk5NmEtM2I4MDM1NzY4NDll%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=e4dbfe59-55e2-4965-b08d-58e67badf71c&directDl=true&msLaunch=true&enableMobilePage=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_YjcyNjcxNWYtN2Q2Mi00ZWJkLTk1MTEtODhiODU0YTc0YjNj%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=4878f9b2-7a9e-4a2d-9399-d8d8547f80bf&directDl=true&msLaunch=true&enableMobilePage=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_ZDRmMGU3MTMtODBiNy00N2M2LThiZTItOGFkMTIzNDg0NWM3%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=ff092e59-55c9-4dec-8490-7eaba0d65e98&directDl=true&msLaunch=true&enableMobilePage=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_M2RjZTRhOGQtMzVmMi00MDJhLWI2MTQtNGFiYWI3ODk4ZDk5%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=8a2a341b-d617-4e7b-ab97-12e1ffb2d787&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_MmQ4OThiOGQtZjVhZC00Nzg0LWIzMTYtYWQ0OGQ2ZGM1MTU2%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=5d190b67-57b9-4538-9a98-f996bd2b6bb2&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_OWM3Y2U1NWMtYmY2ZS00ODg4LWIxZjYtNzgwYmFhYmI5Njhl%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=371093f6-7339-46e7-a5f9-ddd5c715384f&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_ZThkNDg2MTktNWI2Yy00ZTRiLWJlMTYtNDE5YjlhMzYyMWU0%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=3d66e092-b720-446b-9ede-c625964f60ce&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_YzRjNmQzNmUtNGQ4Mi00NDhiLTlkYTMtMGVhYWIyY2RiMWJh%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=d85fb048-58eb-40b4-8054-b7a31598c3b2&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_MTJhZWM1NzAtOGM4My00ZjgzLWIyOTgtMGNlYzY3ZjVhY2Q2%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=805530d2-90aa-428f-b1ac-91944694de38&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_OThlZmU1NjMtMzE0OS00YjdmLWFlYTAtMmRiZDU4NTExNTY0%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%3A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%2C%2522Oid%2522%3A%25221bfe4f91-1cc6-4925-a0d0-fe22e2da79c2%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=d12ec6c3-cc68-4927-a1a7-edb7530eabf9&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
        ],
      ],
      blist: [
        [
          "不工软件(6/23 10AM-12PM)",
          "灰度(6/23 10AM-12PM)",
          "一尺视界(6/23 2PM-4PM)",
          "境腾科技(6/22 4PM-6PM)",
          "无锡睿控(6/23 3PM-5PM)",
          "倍奇能源(6/22 3PM-5PM)",
          "中科国生(6/22 2PM-4PM)",
          "Proxverse(6/22 4PM-6PM)",
          "Xometry(6/22 2PM-4PM)",
          "天俣信(6/24 10AM-12PM)",
          "影彩信息(6/23 1PM-3PM)",
          "可明科技(6/23 4PM-6PM)",
          "深度赋智(6/22 3PM-5PM)",
          "G7(6/24 10AM-12PM)",
        ],

        [
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_NDNkYjc1MTctZjE5Yy00Y2I1LTllZTEtN2ViMGU0NTdiMjc5%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=89f8229d-c477-44ce-920f-a107696cf93c&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_Y2VhOTQyYjMtYTRkNC00Mjc5LThiOTctMmJiOTY4NzA3OTFl%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=5814d8ba-9bfe-45b6-a3c9-35d31f6b90fd&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_YjA2MzEzZWItZDEyYS00MTQ5LThhMDktOTI3YTE5MGI3Yzdi%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=1c9b4527-2e3a-419a-8099-1f60a094f263&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_Yjg1Mjc3YmMtYzkyYi00MWFhLTlkN2ItYWIxZWNlYjYyZWI4%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=c454d23e-2780-41c5-aadc-df03bb4752c4&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_NjQxNDE2OWYtZTQ5My00NTE4LTgyNTktZDBkMzNlMDI0YjM5%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=1d70bd00-c6f3-4781-bfed-ef0f978c96fe&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_ODRhY2M5NWYtNjUzMi00Y2VlLTgwYTUtZTExMmZjNWNkNTg5%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=e628b239-627d-4867-907a-b62979394ba2&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_ZmI1MmQzYWUtOWY2ZC00YTEyLTlkOWMtYmI1MjYxYWE5N2Ni%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=5562bd92-cf5c-4ca6-86eb-09bec6108c1a&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_ZGRkMGFkNjYtOTJjOS00YTBlLWE4N2YtM2ViY2QyYTdhNDhi%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=05651344-d660-454c-8012-b05cb8744d4f&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_YjhlNzEyZGEtYTc5My00ZjY0LWFiYmQtZjAzYzJlNjljYWVk%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=663cf26d-d5f7-47e9-a575-172f1578427d&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_NjM4NzUwMDMtMWI0My00MmYxLThjYTgtMjNiZWM5MDU2N2M4%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=27103cd6-5e2e-442b-ba4a-4968a9d55037&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_YmRmNjgxNmMtOWUzMy00OTY3LTk3OTYtMDVmMDNkNmFkY2Y1%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=d3e82190-f656-47dd-a5e7-be7a8809a5a1&directDl=true&msLaunch=true&enableMobilePage=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_OGYxMmEyNjQtM2YyNi00NWU5LTgyODItZWJmMWE4Y2U3ZWIw%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=90973be7-7986-4d45-a2a3-0ffd1054b741&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_NzhiNzIwMTYtNTJiYi00MDkwLWI3MTktMjE0NzlhNjFjZjY4%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=4b469441-7520-44aa-af1e-fe7bffb4c0ab&directDl=true&msLaunch=true&enableMobilePage=true",
          "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_ZWU0MWNiNjYtYjYwYS00YTE4LTkyMTQtZmFkN2I4ZmI2YjYx%40thread.v2%2F0%3Fcontext%3D%257B%2522Tid%2522%253A%2522e4e1abd9-eac7-4a71-ab52-da5c998aa7ba%2522%252C%2522Oid%2522%253A%2522144b81df-2c28-4adc-b0a6-805fd63654ee%2522%257D%26anon%3Dtrue&type=meetup-join&deeplinkId=2eff9df7-aae5-4b6c-bb22-edfff68d37f4&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true",
        ],
      ],
    };
  },
  methods: {
    closeFlag(e) {
      this.changeFlag = e;
      this.msgFlag = e;
    },

    changeAvatar(e) {
      console.log(e);
      this.role.avatar = e;
      this.$chat.role.avatar = e;
      save({
        name: this.$chat.role.name,
        info: JSON.stringify(this.$chat.role),
      }).then((res) => {});
      // localStorage.setItem("info", JSON.stringify(this.$chat.role));
    },
    handleSelect(key, keyPath) {
      if (keyPath[0] == "1") {
        this.roam(key);
      }

      if (keyPath[0] == "4") {
        this.opento(key);
      }

      if (keyPath[0] == "5") {
        this.opento1(key);
      }

      if (keyPath[0] == "2") {
        if (document.o2.role.state == "sit") {
          this.$message.error("坐下无法换装");
          return;
        }
        this.changeFlag = !this.changeFlag;
        this.msgFlag = false;
      }

      if (keyPath[0] == "3") {
        this.pose(key);
      }

      if (keyPath[0] == "4") {
        this.userFlag = !this.userFlag;
      }
    },
    roam(key) {
      var index = key.split("-")[1];

      console.log(this.$chat.role.auth);
      if (this.$chat.role.auth < 3 && index > 2) {
        this.$message.error("您暂无权限");
        return;
      }
      localStorage.setItem("olytype", index - 1);
      location.reload();
      done();
    },

    getStatus(e) {
      if (e.time0 == null) {
        return 0; //空闲
      }
      var time = new Date().getTime();

      if (time > Number(e.time0) && time < Number(e.time1)) {
        return 1; //正在使用
      }

      if (time < e.time1) {
        return 2; //已预约
      }

      if (time > e.time1) {
        return 3;
        //已过期;
      }
    },

    pose(key) {
      let clipName = "";
      if (key == "3-1") {
        if (document.o2.role.state != "sit") {
          this.$message.error("该动作只有坐下才能使用");
          return;
        }
        clipName = "clap";
      }

      if (key == "3-2") {
        clipName = "Greeting";
      }

      if (clipName && clipName != "") {
        document.o2.role.playClip(clipName, false, false);
        let msg = 1056 + ",";
        let info = { msg: "playClip", data: clipName };
        msg += JSON.stringify(info);
        this.$chat.ws.send(msg);
      }
    },

    loginOut() {
      this.$confirm(this.$t("info.lang.logOutInfo"))
        .then((_) => {
          localStorage.removeItem("info");
          location.reload();
          done();
        })
        .catch((_) => {});
    },

    opento(key) {
      var i = key.split("-")[1];
      var url = this.alist[1][i];
      window.open(url, "_blank");
    },

    opento1(key) {
      var i = key.split("-")[1];
      var url = this.blist[1][i];
      window.open(url, "_blank");
    },
  },
  created() {
    this.Bus.$on("loginS", (e) => {
      this.role = this.$chat.role;
      if (!this.role.avatar) {
        this.role.avatar = 0;
      }
      this.auth = this.$chat.user_power;
    });

    this.Bus.$on("renzheng", () => {
      this.msgFlag = true;
    });

    this.Bus.$on("loginS", () => {
      this.auth = this.$chat.role.auth;
    });
  },
};
</script>
<style lang="scss" scoped>
.img {
  width: 40px;
  float: left;
  margin-right: 20px;
  margin-top: 10px;
  margin-left: 20px;
  border-radius: 50%;
  cursor: pointer;
}
.loginOut {
  color: #fff;
  font-size: 14px;
  padding: 0 20px;
  cursor: pointer;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
  float: right;
  margin-top: 18px;
  display: flex;
}

::v-deep.el-menu {
  opacity: 0.8;
  border: 0 !important;
}
.icon1 {
  margin-right: 5px;
  width: 20px;
  height: 20px;
}

.t {
  position: absolute;
  height: 100%;
  right: 110px;
  top: 2px;
}
.right1 {
  float: right;
}
</style>
